(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["itrh-cart-drawer"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('cart-drawer')) return;

    const shopRoot = () => window.Shopify?.routes?.root || '/';
    const parseHTML = (html) => new DOMParser().parseFromString(html, 'text/html');
    const jsonHeaders = { 'Content-Type': 'application/json', Accept: 'application/json' };

    class ItrhCartDrawer extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.sectionId;
        this.recsMode = this.dataset.recs;
        this.recsLimit = this.dataset.recsLimit || 8;
        this.timers = {};

        this.onClick = this.onClick.bind(this);
        this.onChange = this.onChange.bind(this);
        this.onInput = this.onInput.bind(this);
        document.addEventListener('click', this.onClick);
        document.addEventListener('change', this.onChange);
        document.addEventListener('input', this.onInput);

        if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS) {
          this.unsubscribe = window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, (event) => {
            if (event?.source === 'product-form' || event?.source === 'itrh-cart') return;
            this.refresh();
          });
        }

        this.onSelect = (e) => e.detail?.sectionId === this.sectionId && this.open();
        this.onDeselect = (e) => e.detail?.sectionId === this.sectionId && this.close();
        document.addEventListener('shopify:section:select', this.onSelect);
        document.addEventListener('shopify:section:deselect', this.onDeselect);

        const template = this.querySelector('#ItrhCartRecsTemplate');
        if (template) this.recsHtml = template.innerHTML;
      }

      disconnectedCallback() {
        document.removeEventListener('click', this.onClick);
        document.removeEventListener('change', this.onChange);
        document.removeEventListener('input', this.onInput);
        document.removeEventListener('shopify:section:select', this.onSelect);
        document.removeEventListener('shopify:section:deselect', this.onDeselect);
        this.unsubscribe?.();
      }

      get drawer() {
        return document.getElementById('CartDrawer');
      }

      get main() {
        return document.getElementById('ItrhCartMain');
      }

      /* ------------------------------------------- Dawn-compatible API */
      setActiveElement(element) {
        this.activeElement = element;
      }

      getSectionsToRender() {
        return [{ id: this.sectionId, selector: '#ItrhCartMain' }, { id: 'cart-icon-bubble' }];
      }

      renderContents(state) {
        this.applySections(state?.sections);
        const keys = state?.items ? state.items.map((item) => item.key) : state?.key ? [state.key] : [];
        keys.forEach((key) => {
          this.main?.querySelector(`[data-key="${CSS.escape(key)}"]`)?.classList.add('is-new');
        });
        this.open();
      }

      async open(trigger) {
        await customElements.whenDefined('itrh-drawer');
        const drawer = this.drawer;
        if (!drawer) return;
        if (!drawer.isOpen) {
          const main = this.main;
          main?.classList.add('is-intro');
          clearTimeout(this.introTimer);
          this.introTimer = setTimeout(() => main?.classList.remove('is-intro'), 1600);
        }
        drawer.open(trigger || this.activeElement);
        this.loadRecommendations();
      }

      close() {
        this.drawer?.close();
      }

      /* ------------------------------------------------ Rendering */
      applySections(sections) {
        if (!sections) return;

        const html = sections[this.sectionId];
        const current = this.main;
        if (html && current) {
          const next = parseHTML(html).getElementById('ItrhCartMain');
          if (next) {
            const openPanels = [...current.querySelectorAll('.itrh-cart__expand.is-open')].map((el) => el.id);
            const breakdownOpen = current.querySelector('.itrh-cart__breakdown.is-open');
            const scroll = current.querySelector('.itrh-cart__content')?.scrollTop || 0;

            current.replaceWith(next);

            openPanels.forEach((id) => {
              next.querySelector(`#${id}`)?.classList.add('is-open');
              next.querySelector(`[aria-controls="${id}"]`)?.setAttribute('aria-expanded', 'true');
            });
            if (breakdownOpen) {
              const breakdown = next.querySelector('.itrh-cart__breakdown');
              breakdown?.classList.add('is-open');
              breakdown?.querySelector('[data-summary-toggle]')?.setAttribute('aria-expanded', 'true');
            }
            const content = next.querySelector('.itrh-cart__content');
            if (content) content.scrollTop = scroll;

            this.drawer?.toggleAttribute('data-empty', next.dataset.empty === 'true');
            this.fillRecommendations();
            if (this.recsMode === 'auto' && next.dataset.firstProduct !== this.recsFor) this.loadRecommendations(true);
          }
        }

        const bubbleHtml = sections['cart-icon-bubble'];
        const bubble = document.getElementById('cart-icon-bubble');
        if (bubbleHtml && bubble) {
          const doc = parseHTML(bubbleHtml);
          bubble.innerHTML = (doc.querySelector('.shopify-section') || doc.body).innerHTML;
        }
      }

      async refresh() {
        try {
          const response = await fetch(`${shopRoot()}?sections=${this.sectionId},cart-icon-bubble`);
          this.applySections(await response.json());
        } catch (_) {}
      }

      broadcast(cartData) {
        if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
          window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'itrh-cart', cartData });
        }
        document.dispatchEvent(new CustomEvent('itrh:cart-updated', { detail: cartData }));
      }

      /* -------------------------------------------------- Events */
      onClick(e) {
        const target = e.target;
        if (!target.closest?.('#CartDrawer')) return;

        const step = target.closest('[data-qty-step]');
        if (step) {
          const item = step.closest('[data-key]');
          const input = item.querySelector('[data-qty-input]');
          const increment = Number(input.step) || 1;
          let value = Math.max(0, Number(input.value) + Number(step.dataset.qtyStep) * increment);
          if (input.max) value = Math.min(value, Number(input.max));
          input.value = value;
          if (value === 0) item.closest('.itrh-cart-item-wrap')?.classList.add('is-removing');
          this.queueLine(item.dataset.key, value);
          return;
        }

        const remove = target.closest('[data-remove]');
        if (remove) {
          const item = remove.closest('[data-key]');
          item.closest('.itrh-cart-item-wrap')?.classList.add('is-removing');
          this.updateLine(item.dataset.key, 0);
          return;
        }

        const toggle = target.closest('[data-cart-toggle]');
        if (toggle) {
          const id = toggle.getAttribute('aria-controls');
          const willOpen = toggle.getAttribute('aria-expanded') !== 'true';
          this.main.querySelectorAll('[data-cart-toggle]').forEach((button) => {
            button.setAttribute('aria-expanded', 'false');
            document.getElementById(button.getAttribute('aria-controls'))?.classList.remove('is-open');
          });
          if (willOpen) {
            toggle.setAttribute('aria-expanded', 'true');
            const panel = document.getElementById(id);
            panel?.classList.add('is-open');
            setTimeout(() => panel?.querySelector('input, textarea')?.focus({ preventScroll: true }), 250);
          }
          return;
        }

        const summary = target.closest('[data-summary-toggle]');
        if (summary) {
          const expanded = summary.getAttribute('aria-expanded') !== 'true';
          summary.setAttribute('aria-expanded', String(expanded));
          summary.closest('.itrh-cart__breakdown')?.classList.toggle('is-open', expanded);
          return;
        }

        if (target.closest('[data-discount-apply]')) {
          e.preventDefault();
          this.applyDiscount();
          return;
        }

        const removeCode = target.closest('[data-discount-remove]');
        if (removeCode) {
          this.removeDiscount(removeCode.dataset.discountRemove);
          return;
        }

        const quickAdd = target.closest('[data-quick-add]');
        if (quickAdd) {
          e.preventDefault();
          this.quickAdd(quickAdd);
        }
      }

      onChange(e) {
        const target = e.target;
        if (!target.closest?.('#CartDrawer')) return;

        if (target.matches('[data-qty-input]')) {
          const item = target.closest('[data-key]');
          this.queueLine(item.dataset.key, Math.max(0, Number(target.value) || 0));
        } else if (target.matches('[data-cart-consent]')) {
          const checkout = this.main.querySelector('[data-cart-checkout]');
          if (checkout) checkout.disabled = !target.checked;
          this.main.querySelector('[data-cart-dynamic]')?.classList.toggle('is-locked', !target.checked);
        }
      }

      onInput(e) {
        const target = e.target;
        if (target.matches?.('#CartDrawer [data-cart-note]')) {
          clearTimeout(this.timers.note);
          this.timers.note = setTimeout(() => {
            fetch(`${shopRoot()}cart/update.js`, {
              method: 'POST',
              headers: jsonHeaders,
              body: JSON.stringify({ note: target.value }),
            }).catch(() => {});
          }, 500);
        } else if (target.matches?.('#CartDrawer [data-discount-input]')) {
          const error = this.main.querySelector('[data-discount-error]');
          if (error) error.textContent = '';
        }
      }

      /* ---------------------------------------------- Cart actions */
      queueLine(key, quantity) {
        clearTimeout(this.timers[key]);
        this.timers[key] = setTimeout(() => this.updateLine(key, quantity), 350);
      }

      async updateLine(key, quantity) {
        const item = this.main?.querySelector(`[data-key="${CSS.escape(key)}"]`);
        item?.classList.add('is-loading');
        this.main?.classList.add('is-busy');

        try {
          const response = await fetch(`${shopRoot()}cart/change.js`, {
            method: 'POST',
            headers: jsonHeaders,
            body: JSON.stringify({
              id: key,
              quantity,
              sections: [this.sectionId, 'cart-icon-bubble'],
              sections_url: location.pathname,
            }),
          });
          const data = await response.json();

          if (!response.ok || data.status) {
            this.showItemError(item, data.description || data.message);
            return;
          }

          this.applySections(data.sections);
          this.broadcast(data);
        } catch (_) {
          this.showItemError(item, 'Something went wrong. Please try again.');
        } finally {
          this.main?.classList.remove('is-busy');
        }
      }

      showItemError(item, message) {
        if (!item) return;
        item.classList.remove('is-loading');
        item.closest('.itrh-cart-item-wrap')?.classList.remove('is-removing');
        const input = item.querySelector('[data-qty-input]');
        if (input) input.value = input.defaultValue;
        const error = item.querySelector('[data-item-error]');
        if (error) error.textContent = message || 'Something went wrong. Please try again.';
      }

      async updateDiscounts(codes, attempted) {
        const button = this.main?.querySelector('[data-discount-apply]');
        button?.classList.add('is-loading');
        this.main?.classList.add('is-busy');

        try {
          const response = await fetch(`${shopRoot()}cart/update.js`, {
            method: 'POST',
            headers: jsonHeaders,
            body: JSON.stringify({
              discount: codes.join(','),
              sections: [this.sectionId, 'cart-icon-bubble'],
              sections_url: location.pathname,
            }),
          });
          const data = await response.json();
          this.applySections(data.sections);
          this.broadcast(data);

          if (attempted) {
            const result = data.discount_codes?.find((c) => c.code.toLowerCase() === attempted.toLowerCase());
            if (result && !result.applicable) {
              const error = this.main?.querySelector('[data-discount-error]');
              const input = this.main?.querySelector('[data-discount-input]');
              if (input) input.value = attempted;
              if (error) error.textContent = `“${attempted}” can't be applied to your cart.`;
            }
          }
        } catch (_) {
          const error = this.main?.querySelector('[data-discount-error]');
          if (error) error.textContent = 'Something went wrong. Please try again.';
        } finally {
          button?.classList.remove('is-loading');
          this.main?.classList.remove('is-busy');
        }
      }

      currentCodes() {
        return (this.main?.dataset.discountCodes || '').split(',').map((c) => c.trim()).filter(Boolean);
      }

      applyDiscount() {
        const input = this.main?.querySelector('[data-discount-input]');
        const code = input?.value.trim();
        if (!code) return;
        const codes = this.currentCodes();
        if (codes.some((c) => c.toLowerCase() === code.toLowerCase())) {
          input.value = '';
          return;
        }
        this.updateDiscounts([...codes, code], code);
      }

      removeDiscount(code) {
        this.updateDiscounts(this.currentCodes().filter((c) => c !== code));
      }

      async quickAdd(button) {
        button.classList.add('is-loading');
        try {
          const response = await fetch(`${shopRoot()}cart/add.js`, {
            method: 'POST',
            headers: jsonHeaders,
            body: JSON.stringify({
              items: [{ id: Number(button.dataset.quickAdd), quantity: 1 }],
              sections: [this.sectionId, 'cart-icon-bubble'],
              sections_url: location.pathname,
            }),
          });
          const data = await response.json();
          if (data.status) return;
          this.renderContents(data);
          this.broadcast(data);
        } catch (_) {
        } finally {
          button.classList.remove('is-loading');
        }
      }

      /* ------------------------------------------ Recommendations */
      async loadRecommendations(force = false) {
        if (this.recsMode === 'off') return;
        if (this.recsMode === 'collection') {
          this.fillRecommendations();
          return;
        }

        const productId = this.main?.dataset.firstProduct;
        if (!productId) {
          this.recsFor = '';
          this.recsHtml = '';
          this.fillRecommendations();
          return;
        }
        if (!force && this.recsFor === productId) return;
        this.recsFor = productId;

        try {
          const response = await fetch(
            `${shopRoot()}recommendations/products?section_id=${this.sectionId}&product_id=${productId}&limit=${this.recsLimit}&intent=related`
          );
          const doc = parseHTML(await response.text());
          this.recsHtml = doc.getElementById('ItrhCartRecs')?.innerHTML || '';
        } catch (_) {
          this.recsHtml = '';
        }
        this.fillRecommendations();
      }

      fillRecommendations() {
        const drawer = this.drawer;
        if (!drawer) return;

        const inCart = (this.main?.dataset.productIds || '').split(',');
        const doc = parseHTML(`<div>${this.recsHtml || ''}</div>`);
        doc.querySelectorAll('[data-product-id]').forEach((card) => {
          if (inCart.includes(card.dataset.productId)) card.remove();
        });
        const cards = doc.body.firstElementChild;
        const count = cards.children.length;

        drawer.querySelectorAll('[data-recs-slot]').forEach((slot) => {
          slot.innerHTML = cards.innerHTML;
          [...slot.children].forEach((card, i) => card.style.setProperty('animation-delay', `${i * 60 + 100}ms`));
        });
        const inline = drawer.querySelector('[data-recs-wrap]');
        if (inline) inline.hidden = count === 0;
        drawer.toggleAttribute('data-has-recs', count > 0);
      }
    }

    customElements.define('cart-drawer', ItrhCartDrawer);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["itrh-collection-list"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const bind = (carousel) => {
      if (carousel.dataset.progressBound) return;
      const bar = carousel.querySelector('[data-clist-progress]');
      const hook = () => {
        const embla = carousel.embla;
        if (!embla) return false;
        carousel.dataset.progressBound = 'true';
        if (!bar) return true;
        const update = () => {
          const snaps = embla.scrollSnapList().length || 1;
          const width = Math.max(100 / snaps, 12);
          const progress = Math.max(0, Math.min(1, embla.scrollProgress()));
          bar.style.setProperty('--progress-w', `${width}%`);
          bar.style.setProperty('--progress-x', `${progress * (100 / width - 1) * 100}%`);
        };
        embla.on('scroll', update).on('reInit', update);
        update();
        return true;
      };
      if (!hook()) {
        const timer = setInterval(() => hook() && clearInterval(timer), 250);
        setTimeout(() => clearInterval(timer), 10000);
      }
    };
    const init = () => document.querySelectorAll('[data-clist-carousel]').forEach(bind);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
    else init();
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["itrh-contact-form"] && !Shopify.designMode) return;
  try {
    
  (() => {
    // Bring the success or error message into view after the page reloads
    const notice = document.querySelector('[data-contact-notice]');
    if (!notice) return;
    requestAnimationFrame(() => {
      notice.scrollIntoView({ behavior: 'smooth', block: 'center' });
      notice.focus({ preventScroll: true });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["itrh-email-signup-banner"] && !Shopify.designMode) return;
  try {
    
  (() => {
    // Bring the signup message into view after the page reloads
    const msg = document.querySelector('[data-esb-msg]');
    if (!msg) return;
    requestAnimationFrame(() => {
      msg.scrollIntoView({ block: 'center' });
      if (msg.hasAttribute('tabindex')) msg.focus({ preventScroll: true });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["itrh-footer"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.itrhFooterToggle) return;
    window.itrhFooterToggle = true;

    document.addEventListener('click', (e) => {
      const toggle = e.target.closest('[data-footer-toggle]');
      if (!toggle) return;
      const block = toggle.closest('.itrh-ft__block');
      const open = !block.classList.contains('is-open');
      block.classList.toggle('is-open', open);
      toggle.setAttribute('aria-expanded', String(open));
    });

    // After a newsletter signup the page reloads: bring the message into view.
    const message = document.querySelector('.itrh-ft__msg');
    if (message) {
      message.closest('.itrh-ft__block[data-collapsible]')?.classList.add('is-open');
      requestAnimationFrame(() => message.scrollIntoView({ block: 'center' }));
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["itrh-header"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('itrh-header')) return;

    const desktop = matchMedia('(min-width: 768px)');
    const root = document.documentElement;

    class ItrhHeader extends HTMLElement {
      connectedCallback() {
        this.section = this.closest('.shopify-section');
        let prev = this.section?.previousElementSibling;
        while (prev && !prev.classList.contains('itrh-ab-section') && prev.offsetHeight === 0) {
          prev = prev.previousElementSibling;
        }
        this.bar = this.hasAttribute('data-sticky-bar') && prev?.classList.contains('itrh-ab-section') ? prev : null;
        this.clickMode = this.hasAttribute('data-open-on-click');
        this.lastY = scrollY;

        this.measure = this.measure.bind(this);
        this.resizeObserver = new ResizeObserver(this.measure);
        this.resizeObserver.observe(this);
        if (this.bar) this.resizeObserver.observe(this.bar);

        this.onScroll = () => {
          if (this.ticking) return;
          this.ticking = true;
          requestAnimationFrame(() => this.update());
        };
        addEventListener('scroll', this.onScroll, { passive: true });

        this.onMedia = () => {
          this.closeMenu();
          this.applySticky();
        };
        desktop.addEventListener('change', this.onMedia);

        this.onDrawer = (e) => {
          const open = e.type === 'itrh:drawer-open';
          this.drawerOpen = open;
          if (open) this.setHidden(false);
          this.updateSolid();
        };
        document.addEventListener('itrh:drawer-open', this.onDrawer);
        document.addEventListener('itrh:drawer-close', this.onDrawer);

        this.initMenu();
        this.initCart();
        this.applySticky();
        this.measure();
      }

      disconnectedCallback() {
        this.resizeObserver.disconnect();
        removeEventListener('scroll', this.onScroll);
        desktop.removeEventListener('change', this.onMedia);
        document.removeEventListener('itrh:drawer-open', this.onDrawer);
        document.removeEventListener('itrh:drawer-close', this.onDrawer);
        document.removeEventListener('click', this.onDocClick);
        this.cartObserver?.disconnect();
        delete root.dataset.itrhSticky;
        delete root.dataset.itrhStickyBar;
        delete root.dataset.itrhHeaderHidden;
      }

      measure() {
        root.style.setProperty('--itrh-header-h', `${this.querySelector('.itrh-hd__bar').offsetHeight}px`);
        root.style.setProperty('--itrh-bar-h', `${this.bar?.offsetHeight || 0}px`);
      }

      applySticky() {
        this.mode = desktop.matches ? this.dataset.stickyDesktop : this.dataset.stickyMobile;
        if (this.mode && this.mode !== 'none') {
          root.dataset.itrhSticky = this.mode;
          if (this.bar) root.dataset.itrhStickyBar = '';
          else delete root.dataset.itrhStickyBar;
        } else {
          delete root.dataset.itrhSticky;
          delete root.dataset.itrhStickyBar;
        }
        this.setHidden(false);
        this.update();
      }

      update() {
        this.ticking = false;
        const y = Math.max(scrollY, 0);
        const sticky = this.mode && this.mode !== 'none';
        this.classList.toggle('is-scrolled', sticky && y > 0);

        if (this.mode === 'dynamic' && !this.menuOpen && !this.drawerOpen) {
          const threshold = this.offsetHeight + (this.bar?.offsetHeight || 0);
          const delta = y - this.lastY;
          if (y <= threshold) {
            this.setHidden(false);
            this.lastY = y;
          } else if (Math.abs(delta) > 8) {
            this.setHidden(delta > 0);
            this.lastY = y;
          }
        } else {
          this.lastY = y;
        }
        this.updateSolid();
      }

      setHidden(hidden) {
        if (this.isHidden === hidden) return;
        this.isHidden = hidden;
        if (hidden) {
          root.dataset.itrhHeaderHidden = '';
          this.closeMenu();
        } else {
          delete root.dataset.itrhHeaderHidden;
        }
      }

      updateSolid() {
        this.classList.toggle(
          'is-solid',
          Boolean(this.hovered || this.menuOpen || this.drawerOpen || this.classList.contains('is-scrolled'))
        );
      }

      /* ---------------------------------------------------------- Menus */
      initMenu() {
        this.items = [...this.querySelectorAll('[data-menu-item]')];
        this.mega = this.querySelector('[data-mega-bg]');

        this.addEventListener('pointerdown', (e) => (this.lastPointer = e.pointerType));

        this.items.forEach((item) => {
          const trigger = item.querySelector('[data-menu-trigger]');

          if (!this.clickMode) {
            item.addEventListener('pointerenter', (e) => {
              if (e.pointerType !== 'mouse') return;
              clearTimeout(this.closeTimer);
              clearTimeout(this.openTimer);
              this.openTimer = setTimeout(
                () => (item.dataset.panel ? this.openMenu(item) : this.closeMenu()),
                this.menuOpen ? 0 : 40
              );
            });
          }

          if (!trigger) return;

          trigger.addEventListener('click', (e) => {
            const touch = this.lastPointer && this.lastPointer !== 'mouse';
            if (this.clickMode || (touch && this.current !== item)) {
              e.preventDefault();
              this.current === item ? this.closeMenu() : this.openMenu(item);
            }
          });

          trigger.addEventListener('keydown', (e) => {
            if (e.key !== 'ArrowDown') return;
            e.preventDefault();
            this.openMenu(item);
            this.panelOf(item)?.querySelector('a, button')?.focus();
          });
        });

        this.querySelectorAll('.itrh-hd__logo, .itrh-hd__icons').forEach((zone) => {
          zone.addEventListener('pointerenter', (e) => {
            if (e.pointerType !== 'mouse' || this.clickMode) return;
            clearTimeout(this.openTimer);
            this.closeTimer = setTimeout(() => this.closeMenu(), 120);
          });
        });

        this.addEventListener('pointerenter', (e) => {
          if (e.pointerType !== 'mouse') return;
          this.hovered = true;
          clearTimeout(this.closeTimer);
          this.updateSolid();
        });

        this.addEventListener('pointerleave', (e) => {
          if (e.pointerType !== 'mouse') return;
          this.hovered = false;
          clearTimeout(this.openTimer);
          if (!this.clickMode) this.closeTimer = setTimeout(() => this.closeMenu(), 180);
          this.updateSolid();
        });

        this.addEventListener('focusin', (e) => {
          if (this.clickMode || this.lastPointer === 'mouse') return;
          const item = e.target.closest('[data-menu-item]');
          if (item) item.dataset.panel ? this.openMenu(item) : this.closeMenu();
        });

        this.addEventListener('focusout', (e) => {
          if (!this.contains(e.relatedTarget)) this.closeMenu();
        });

        this.addEventListener('keydown', (e) => {
          if (e.key !== 'Escape' || !this.current) return;
          const trigger = this.current.querySelector('[data-menu-trigger]');
          this.closeMenu();
          trigger?.focus();
        });

        this.onDocClick = (e) => {
          if (this.current && !this.contains(e.target)) this.closeMenu();
        };
        document.addEventListener('click', this.onDocClick);
      }

      panelOf(item) {
        return item?.dataset.panel ? document.getElementById(item.dataset.panel) : null;
      }

      openMenu(item) {
        if (this.current === item) return;
        this.deactivate(this.current);

        this.current = item;
        item.classList.add('is-open');
        item.querySelector('[data-menu-trigger]')?.setAttribute('aria-expanded', 'true');

        const panel = this.panelOf(item);
        panel?.classList.add('is-active');
        if (this.mega) {
          this.mega.style.height = panel?.matches('[data-mega-panel]') ? `${panel.offsetHeight}px` : '0px';
        }

        root.style.setProperty('--itrh-header-bottom', `${this.getBoundingClientRect().bottom}px`);
        this.menuOpen = true;
        this.classList.add('is-menu-open');
        this.updateSolid();
      }

      closeMenu() {
        if (!this.current) return;
        this.deactivate(this.current);
        this.current = null;
        if (this.mega) this.mega.style.height = '0px';
        this.menuOpen = false;
        this.classList.remove('is-menu-open');
        this.updateSolid();
      }

      deactivate(item) {
        if (!item) return;
        item.classList.remove('is-open');
        item.querySelector('[data-menu-trigger]')?.setAttribute('aria-expanded', 'false');
        this.panelOf(item)?.classList.remove('is-active');
      }

      /* ----------------------------------------------------------- Cart */
      initCart() {
        this.querySelectorAll('[data-cart-open]').forEach((link) => {
          link.addEventListener('click', (e) => {
            const drawer = document.querySelector('cart-drawer');
            if (!drawer || typeof drawer.open !== 'function') return;
            e.preventDefault();
            drawer.open(link);
          });
        });

        const bubble = this.querySelector('#cart-icon-bubble');
        const cart = this.querySelector('.itrh-hd__cart');
        if (!bubble || !cart) return;
        this.cartObserver = new MutationObserver(() => {
          cart.classList.remove('is-bump');
          void cart.offsetWidth;
          cart.classList.add('is-bump');
        });
        this.cartObserver.observe(bubble, { childList: true, subtree: true, characterData: true });
      }
    }

    customElements.define('itrh-header', ItrhHeader);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["itrh-lookbook"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.itrhLookbookReady) return;
    window.itrhLookbookReady = true;

    // Keep the sticky image clear of the header, and let tall images scroll fully into view
    const place = () => {
      const root = document.documentElement;
      const headerVisible =
        root.dataset.itrhSticky === 'static' ||
        (root.dataset.itrhSticky === 'dynamic' && !root.hasAttribute('data-itrh-header-hidden'));
      const headerHeight = headerVisible
        ? parseFloat(getComputedStyle(root).getPropertyValue('--itrh-header-h')) || 0
        : 0;

      document.querySelectorAll('.itrh-lb--sticky').forEach((section) => {
        const figure = section.querySelector('.itrh-lb__figure');
        if (!figure) return;
        const top = headerHeight + 24;
        const overflow = window.innerHeight - figure.offsetHeight - 24;
        figure.style.setProperty('--lb-sticky-top', `${Math.min(top, overflow)}px`);
      });
    };

    const start = () => {
      place();
      addEventListener('resize', place, { passive: true });
      new MutationObserver(place).observe(document.documentElement, {
        attributes: true,
        attributeFilter: ['data-itrh-header-hidden', 'data-itrh-sticky'],
      });
      document.querySelectorAll('.itrh-lb__figure').forEach((figure) => new ResizeObserver(place).observe(figure));
    };

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
    else start();
    document.addEventListener('shopify:section:load', place);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["itrh-main-article"]) return;
  try {
    
  (() => {
    if (window.itrhArticleReady) return;
    window.itrhArticleReady = true;

    document.addEventListener('click', async (e) => {
      // Copy link, or open the phone's share sheet when available
      const copy = e.target.closest('[data-art-copy]');
      if (copy) {
        const url = copy.dataset.artCopy;
        const coarse = window.matchMedia('(pointer: coarse)').matches;
        if (coarse && navigator.share) {
          try {
            await navigator.share({ title: document.title, url });
          } catch (_) {}
          return;
        }
        try {
          await navigator.clipboard.writeText(url);
        } catch (_) {
          window.prompt('Copy this link', url);
          return;
        }
        const tip = copy.querySelector('[data-art-copied]');
        if (tip) {
          tip.hidden = false;
          clearTimeout(copy._tipTimer);
          copy._tipTimer = setTimeout(() => (tip.hidden = true), 1800);
        }
        return;
      }

      // "+N more" tags
      const more = e.target.closest('[data-art-tags-toggle]');
      if (more) {
        more.closest('[data-art-tags]').classList.add('is-expanded');
        more.parentElement.remove();
      }
    });

    // Scroll to the comment notice after the form posts
    const showNotice = () => {
      const notice = document.querySelector('[data-art-notice]');
      if (!notice) return;
      notice.scrollIntoView({ block: 'center' });
      notice.focus({ preventScroll: true });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', showNotice, { once: true });
    else showNotice();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["itrh-main-blog"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.itrhBlogReady) return;
    window.itrhBlogReady = true;

    // "+N more" tag toggle
    document.addEventListener('click', (e) => {
      const toggle = e.target.closest('[data-blog-tags-toggle]');
      if (!toggle) return;
      const nav = toggle.closest('[data-blog-tags]');
      const open = !nav.classList.contains('is-expanded');
      nav.classList.toggle('is-expanded', open);
      toggle.setAttribute('aria-expanded', String(open));
      toggle.querySelector('[data-more-label]').hidden = open;
      toggle.querySelector('[data-less-label]').hidden = !open;
    });

    // Load more posts without leaving the page
    const loadMore = async (button) => {
      if (button.classList.contains('is-loading')) return;
      button.classList.add('is-loading');
      try {
        const html = await (await fetch(button.href)).text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const grid = document.querySelector('[data-blog-grid]');
        const nextItems = doc.querySelectorAll('[data-blog-grid] > *');
        nextItems.forEach((item) => {
          item.removeAttribute('data-reveal');
          grid.append(item);
        });

        const nextPager = doc.querySelector('[data-blog-pager]');
        const pager = button.closest('[data-blog-pager]');
        if (nextPager) pager.replaceWith(nextPager);
        else pager.remove();

        history.replaceState(history.state, '', button.href);
        observe();
      } catch (_) {
        window.location.href = button.href;
      }
    };

    document.addEventListener('click', (e) => {
      const button = e.target.closest('[data-blog-more]');
      if (!button) return;
      e.preventDefault();
      loadMore(button);
    });

    // Infinite scroll: load the next page as the button comes into view
    let observer;
    const observe = () => {
      const button = document.querySelector('[data-blog-more][data-infinite]');
      if (!button || !('IntersectionObserver' in window)) return;
      observer?.disconnect();
      observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) loadMore(button);
        },
        { rootMargin: '400px 0px' }
      );
      observer.observe(button);
    };

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', observe, { once: true });
    else observe();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["itrh-main-cart"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('itrh-cart-page')) return;

    const root = () => window.Shopify?.routes?.root || '/';
    const json = { 'Content-Type': 'application/json', Accept: 'application/json' };
    const parse = (html) => new DOMParser().parseFromString(html, 'text/html');
    const escapeHtml = (value = '') =>
      String(value).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);

    class ItrhCartPage extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.sectionId;
        this.timers = {};

        this.addEventListener('click', (e) => this.onClick(e));
        this.addEventListener('change', (e) => this.onChange(e));
        this.addEventListener('input', (e) => this.onInput(e));

        if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS) {
          this.unsubscribe = window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, (event) => {
            if (event?.source === 'itrh-cart-page') return;
            this.refresh();
          });
        }

        this.initShipping();
        this.loadRecommendations();
      }

      disconnectedCallback() {
        this.unsubscribe?.();
      }

      get rootEl() {
        return this.querySelector('[data-cart-root]');
      }

      /* ------------------------------------------------------ Rendering */
      apply(sections) {
        if (!sections) return;
        const html = sections[this.sectionId];
        const current = this.rootEl;
        if (html && current) {
          const next = parse(html).querySelector('[data-cart-root]');
          if (next) {
            const openPane = current.querySelector('[data-cp-pane].is-open')?.dataset.cpPane;
            const breakdownOpen = current.querySelector('.itrh-cartpage__breakdown')?.classList.contains('is-open');
            const consentChecked = current.querySelector('[data-cp-consent]')?.checked;
            const shipState = this.readShipping(current);

            // Keep the recommendations carousel as it is (no re-initialising).
            const oldRecs = current.querySelector('[data-cp-recs-wrap]');
            const newRecs = next.querySelector('[data-cp-recs-wrap]');
            if (oldRecs && newRecs) newRecs.replaceWith(oldRecs);

            current.replaceWith(next);

            if (openPane) this.setPane(openPane, true, false);
            const breakdown = next.querySelector('.itrh-cartpage__breakdown');
            if (breakdown && breakdownOpen !== undefined) {
              breakdown.classList.toggle('is-open', breakdownOpen);
              breakdown.querySelector('[data-cp-breakdown]')?.setAttribute('aria-expanded', String(breakdownOpen));
            }
            if (consentChecked) {
              const consent = next.querySelector('[data-cp-consent]');
              if (consent) {
                consent.checked = true;
                this.syncConsent(consent);
              }
            }
            this.initShipping(shipState);
            window.Shopify?.PaymentButton?.init?.();
            if (next.dataset.firstProduct !== this.recsFor) this.loadRecommendations(true);
            else this.filterRecommendations();
            if (next.dataset.empty === 'true') window.scrollTo({ top: 0, behavior: 'smooth' });
          }
        }

        const bubbleHtml = sections['cart-icon-bubble'];
        const bubble = document.getElementById('cart-icon-bubble');
        if (bubbleHtml && bubble) {
          const doc = parse(bubbleHtml);
          bubble.innerHTML = (doc.querySelector('.shopify-section') || doc.body).innerHTML;
        }
      }

      async refresh() {
        try {
          const response = await fetch(`${root()}cart?sections=${this.sectionId},cart-icon-bubble`);
          this.apply(await response.json());
        } catch (_) {}
      }

      broadcast(data) {
        if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
          window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'itrh-cart-page', cartData: data });
        }
      }

      /* --------------------------------------------------------- Events */
      onClick(e) {
        const t = e.target;

        const step = t.closest('[data-cp-step]');
        if (step) {
          const row = step.closest('[data-key]');
          const input = row.querySelector('[data-cp-qty]');
          const inc = Number(input.step) || 1;
          let value = Math.max(0, Number(input.value) + Number(step.dataset.cpStep) * inc);
          if (input.max) value = Math.min(Number(input.max), value);
          input.value = value;
          if (value === 0) row.closest('.itrh-cartpage__row-wrap')?.classList.add('is-removing');
          this.queue(row.dataset.key, value);
          return;
        }

        const remove = t.closest('[data-cp-remove]');
        if (remove) {
          const row = remove.closest('[data-key]');
          row.closest('.itrh-cartpage__row-wrap')?.classList.add('is-removing');
          this.update(row.dataset.key, 0);
          return;
        }

        const tool = t.closest('[data-cp-tool]');
        if (tool) {
          const name = tool.dataset.cpTool;
          const isOpen = tool.getAttribute('aria-expanded') === 'true';
          this.setPane(name, !isOpen, true);
          return;
        }

        const breakdown = t.closest('[data-cp-breakdown]');
        if (breakdown) {
          const wrap = breakdown.closest('.itrh-cartpage__breakdown');
          const open = !wrap.classList.contains('is-open');
          wrap.classList.toggle('is-open', open);
          breakdown.setAttribute('aria-expanded', String(open));
          return;
        }

        if (t.closest('[data-cp-discount-apply]')) {
          this.applyDiscount();
          return;
        }

        const removeCode = t.closest('[data-cp-discount-remove]');
        if (removeCode) {
          this.setDiscounts(this.codes().filter((c) => c !== removeCode.dataset.cpDiscountRemove));
          return;
        }

        if (t.closest('[data-cp-ship-calc]')) this.calculateShipping();
      }

      onChange(e) {
        const t = e.target;
        if (t.matches('[data-cp-qty]')) {
          const row = t.closest('[data-key]');
          this.queue(row.dataset.key, Math.max(0, Number(t.value) || 0));
        } else if (t.matches('[data-cp-consent]')) {
          this.syncConsent(t);
        } else if (t.matches('[data-cp-ship-country]')) {
          this.fillProvinces();
        }
      }

      onInput(e) {
        const t = e.target;
        if (t.matches('[data-cp-note]')) {
          const status = this.querySelector('[data-cp-note-status]');
          if (status) status.textContent = '';
          clearTimeout(this.timers.note);
          this.timers.note = setTimeout(async () => {
            try {
              await fetch(`${root()}cart/update.js`, { method: 'POST', headers: json, body: JSON.stringify({ note: t.value }) });
              if (status) status.textContent = 'Saved';
            } catch (_) {}
          }, 600);
        } else if (t.matches('[data-cp-discount-input]')) {
          const error = this.querySelector('[data-cp-discount-error]');
          if (error) error.textContent = '';
        }
      }

      onKey(e) {
        if (e.key !== 'Enter') return;
        if (e.target.matches('[data-cp-discount-input]')) {
          e.preventDefault();
          this.applyDiscount();
        } else if (e.target.matches('[data-cp-ship-zip]')) {
          e.preventDefault();
          this.calculateShipping();
        }
      }

      setPane(name, open, focus) {
        this.querySelectorAll('[data-cp-tool]').forEach((button) => {
          button.setAttribute('aria-expanded', String(open && button.dataset.cpTool === name));
        });
        this.querySelectorAll('[data-cp-pane]').forEach((pane) => {
          pane.classList.toggle('is-open', open && pane.dataset.cpPane === name);
        });
        if (open && focus) {
          const pane = this.querySelector(`[data-cp-pane="${name}"]`);
          setTimeout(() => pane?.querySelector('textarea, input')?.focus({ preventScroll: true }), 250);
        }
      }

      syncConsent(input) {
        const checkout = this.querySelector('[data-cp-checkout]');
        if (checkout) checkout.disabled = !input.checked;
        this.querySelector('[data-cp-dynamic]')?.classList.toggle('is-locked', !input.checked);
      }

      /* ---------------------------------------------------- Cart actions */
      queue(key, quantity) {
        clearTimeout(this.timers[key]);
        this.timers[key] = setTimeout(() => this.update(key, quantity), 350);
      }

      async update(key, quantity) {
        const row = this.querySelector(`[data-key="${CSS.escape(key)}"]`);
        row?.classList.add('is-loading');
        this.classList.add('is-busy');
        try {
          const response = await fetch(`${root()}cart/change.js`, {
            method: 'POST',
            headers: json,
            body: JSON.stringify({ id: key, quantity, sections: [this.sectionId, 'cart-icon-bubble'], sections_url: location.pathname }),
          });
          const data = await response.json();
          if (!response.ok || data.status) {
            this.rowError(row, data.description || data.message);
            return;
          }
          this.apply(data.sections);
          this.broadcast(data);
        } catch (_) {
          this.rowError(row, 'Something went wrong. Please try again.');
        } finally {
          this.classList.remove('is-busy');
        }
      }

      rowError(row, message) {
        if (!row) return;
        row.classList.remove('is-loading');
        row.closest('.itrh-cartpage__row-wrap')?.classList.remove('is-removing');
        const input = row.querySelector('[data-cp-qty]');
        if (input) input.value = input.defaultValue;
        const error = row.querySelector('[data-item-error]');
        if (error) error.textContent = message || 'Something went wrong. Please try again.';
      }

      codes() {
        return (this.rootEl?.dataset.discountCodes || '').split(',').map((c) => c.trim()).filter(Boolean);
      }

      applyDiscount() {
        const input = this.querySelector('[data-cp-discount-input]');
        const code = input?.value.trim();
        if (!code) return;
        const codes = this.codes();
        if (codes.some((c) => c.toLowerCase() === code.toLowerCase())) {
          input.value = '';
          return;
        }
        this.setDiscounts([...codes, code], code);
      }

      async setDiscounts(codes, attempted) {
        const button = this.querySelector('[data-cp-discount-apply]');
        button?.classList.add('is-loading');
        this.classList.add('is-busy');
        try {
          const response = await fetch(`${root()}cart/update.js`, {
            method: 'POST',
            headers: json,
            body: JSON.stringify({ discount: codes.join(','), sections: [this.sectionId, 'cart-icon-bubble'], sections_url: location.pathname }),
          });
          const data = await response.json();
          this.apply(data.sections);
          this.broadcast(data);
          if (attempted) {
            const result = data.discount_codes?.find((c) => c.code.toLowerCase() === attempted.toLowerCase());
            if (result && !result.applicable) {
              const input = this.querySelector('[data-cp-discount-input]');
              const error = this.querySelector('[data-cp-discount-error]');
              if (input) input.value = attempted;
              if (error) error.textContent = `“${attempted}” can't be applied to your cart.`;
            }
          }
        } catch (_) {
          const error = this.querySelector('[data-cp-discount-error]');
          if (error) error.textContent = 'Something went wrong. Please try again.';
        } finally {
          this.querySelector('[data-cp-discount-apply]')?.classList.remove('is-loading');
          this.classList.remove('is-busy');
        }
      }

      /* ------------------------------------------------ Shipping estimate */
      initShipping(state) {
        this.querySelectorAll('[data-cp-discount-input], [data-cp-ship-zip]').forEach((input) => {
          input.addEventListener('keydown', (e) => this.onKey(e));
        });
        const country = this.querySelector('[data-cp-ship-country]');
        if (!country) return;
        const wanted = state?.country || country.dataset.default;
        if (wanted) {
          const option = [...country.options].find((o) => o.value === wanted || o.textContent.trim() === wanted);
          if (option) country.value = option.value;
        }
        this.fillProvinces(state?.province);
        if (state?.zip) this.querySelector('[data-cp-ship-zip]').value = state.zip;
        if (state?.result) this.querySelector('[data-cp-ship-result]').innerHTML = state.result;
      }

      readShipping(scope) {
        const country = scope.querySelector('[data-cp-ship-country]');
        if (!country) return null;
        return {
          country: country.value,
          province: scope.querySelector('[data-cp-ship-province]')?.value,
          zip: scope.querySelector('[data-cp-ship-zip]')?.value,
          result: scope.querySelector('[data-cp-ship-result]')?.innerHTML,
        };
      }

      fillProvinces(selected) {
        const country = this.querySelector('[data-cp-ship-country]');
        const wrap = this.querySelector('[data-cp-ship-province-wrap]');
        const select = this.querySelector('[data-cp-ship-province]');
        if (!country || !wrap || !select) return;
        let provinces = [];
        try {
          provinces = JSON.parse(country.selectedOptions[0]?.dataset.provinces || '[]');
        } catch (_) {}
        select.innerHTML = provinces.map(([value, label]) => `<option value="${escapeHtml(value)}">${escapeHtml(label)}</option>`).join('');
        if (selected) select.value = selected;
        wrap.hidden = provinces.length === 0;
      }

      async calculateShipping() {
        const result = this.querySelector('[data-cp-ship-result]');
        const button = this.querySelector('[data-cp-ship-calc]');
        const country = this.querySelector('[data-cp-ship-country]')?.value || '';
        const provinceWrap = this.querySelector('[data-cp-ship-province-wrap]');
        const province = provinceWrap && !provinceWrap.hidden ? this.querySelector('[data-cp-ship-province]').value : '';
        const zip = this.querySelector('[data-cp-ship-zip]')?.value.trim() || '';
        if (!result) return;

        const params = new URLSearchParams({
          'shipping_address[country]': country,
          'shipping_address[province]': province,
          'shipping_address[zip]': zip,
        });

        button?.classList.add('is-loading');
        result.innerHTML = '<p>Calculating…</p>';

        try {
          const prepare = await fetch(`${root()}cart/prepare_shipping_rates.json?${params}`, { method: 'POST' });
          if (!prepare.ok) {
            const error = await prepare.json().catch(() => ({}));
            const messages = Object.entries(error)
              .map(([field, list]) => `${field.replace(/_/g, ' ')} ${[].concat(list).join(', ')}`)
              .join('. ');
            result.innerHTML = `<p class="is-error">${escapeHtml(messages || 'Please check your address.')}</p>`;
            return;
          }

          let rates = null;
          for (let attempt = 0; attempt < 10 && !rates; attempt += 1) {
            const response = await fetch(`${root()}cart/async_shipping_rates.json?${params}`);
            if (response.status === 200) {
              const data = await response.json();
              if (data.shipping_rates) rates = data.shipping_rates;
            }
            if (!rates) await new Promise((r) => setTimeout(r, 600));
          }

          if (!rates || rates.length === 0) {
            result.innerHTML = '<p>No shipping options are available for this address.</p>';
            return;
          }

          const format = (amount, currency) => {
            const value = Number(amount);
            if (value === 0) return 'Free';
            try {
              return new Intl.NumberFormat(document.documentElement.lang || undefined, {
                style: 'currency',
                currency: currency || window.Shopify?.currency?.active || 'INR',
                minimumFractionDigits: value % 1 === 0 ? 0 : 2,
              }).format(value);
            } catch (_) {
              return value.toFixed(2);
            }
          };

          result.innerHTML = `
            <p>${rates.length === 1 ? 'There is one shipping option' : `There are ${rates.length} shipping options`}:</p>
            <ul role="list">
              ${rates.map((rate) => `<li><span>${escapeHtml(rate.name)}</span><strong>${format(rate.price, rate.currency)}</strong></li>`).join('')}
            </ul>`;
        } catch (_) {
          result.innerHTML = '<p class="is-error">Something went wrong. Please try again.</p>';
        } finally {
          button?.classList.remove('is-loading');
        }
      }

      /* ------------------------------------------------ Recommendations */
      async loadRecommendations(force = false) {
        if (this.dataset.recs !== 'auto') return;
        const wrap = this.querySelector('[data-cp-recs-wrap]');
        const productId = this.rootEl?.dataset.firstProduct;
        if (!wrap) return;
        if (!productId) {
          wrap.hidden = true;
          return;
        }
        if (!force && this.recsFor === productId) return;
        this.recsFor = productId;

        let recsHtml = '';
        try {
          const limit = Number(this.dataset.recsLimit || 8) + 4;
          const html = await (await fetch(`${root()}recommendations/products?section_id=${this.sectionId}&product_id=${productId}&limit=${limit}&intent=related`)).text();
          recsHtml = parse(html).getElementById('ItrhCartPageRecs')?.innerHTML || '';
        } catch (_) {}

        const doc = parse(`<div>${recsHtml}</div>`);
        const inCart = (this.rootEl?.dataset.productIds || '').split(',');
        const slides = [...doc.body.firstElementChild.children]
          .filter((slide) => !inCart.includes(slide.dataset.productId))
          .slice(0, Number(this.dataset.recsLimit || 8));

        if (!slides.length) {
          wrap.hidden = true;
          return;
        }

        const oldCarousel = wrap.querySelector('[data-cp-recs-carousel]');
        const carousel = oldCarousel.cloneNode(true);
        carousel.removeAttribute('data-ready');
        carousel.removeAttribute('data-static');
        const track = carousel.querySelector('[data-cp-recs-track]');
        track.removeAttribute('style');
        track.replaceChildren(...slides);
        oldCarousel.replaceWith(carousel);
        wrap.hidden = false;
        window.itrh?.reveal?.();
      }

      filterRecommendations() {
        const inCart = (this.rootEl?.dataset.productIds || '').split(',');
        this.querySelectorAll('[data-cp-recs-track] [data-product-id]').forEach((slide) => {
          if (inCart.includes(slide.dataset.productId)) slide.remove();
        });
      }
    }

    customElements.define('itrh-cart-page', ItrhCartPage);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["itrh-main-product"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('itrh-product')) return;

    const shopRoot = () => window.Shopify?.routes?.root || '/';
    const desktop = matchMedia('(min-width: 992px)');

    /* ---------------------------------------------------------- Gallery */
    class ItrhGallery extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-gallery-track]');
        this.dots = this.querySelector('[data-gallery-dots]');
        this.buildDots();
        this.onScroll = () => {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => this.updateDots());
        };
        this.track.addEventListener('scroll', this.onScroll, { passive: true });

        this.addEventListener('click', (e) => {
          const zoom = e.target.closest('[data-zoom]');
          if (!zoom) return;
          const owner = this.closest('.shopify-section')?.id;
          document.querySelector(`itrh-lightbox[data-owner="${owner}"]`)?.open(zoom.dataset.zoom);
        });
      }

      get items() {
        return [...this.track.querySelectorAll('.itrh-gallery__item')];
      }

      buildDots() {
        if (!this.dots) return;
        this.dots.replaceChildren(
          ...this.items.map(() => {
            const dot = document.createElement('span');
            dot.className = 'itrh-gallery__dot';
            return dot;
          })
        );
        this.updateDots();
      }

      updateDots() {
        if (!this.dots || desktop.matches) return;
        const items = this.items;
        const width = items[0]?.offsetWidth || 1;
        const index = Math.min(items.length - 1, Math.round(this.track.scrollLeft / width));
        [...this.dots.children].forEach((dot, i) => dot.classList.toggle('is-active', i === index));
      }

      setActiveMedia(id) {
        const item = this.track.querySelector(`[data-media-id="${id}"]`);
        if (!item) return;
        if (item !== this.track.firstElementChild) {
          this.track.prepend(item);
          item.classList.remove('is-moved');
          void item.offsetWidth;
          item.classList.add('is-moved');
        }
        if (desktop.matches) {
          const top = this.getBoundingClientRect().top;
          if (top < 0) window.scrollBy({ top: top - 24, behavior: 'smooth' });
        } else {
          this.track.scrollTo({ left: 0, behavior: 'smooth' });
        }
        this.updateDots();
      }
    }

    /* --------------------------------------------------------- Lightbox */
    class ItrhLightbox extends HTMLElement {
      connectedCallback() {
        if (this.parentElement !== document.body) {
          this.dataset.owner = this.closest('.shopify-section')?.id || '';
          this.product = this.closest('itrh-product');
          document.body.append(this);
          return;
        }
        if (this.ready) return;
        this.ready = true;
        this.track = this.querySelector('[data-lightbox-track]');
        this.counter = this.querySelector('[data-lightbox-counter]');
        this.prev = this.querySelector('[data-lightbox-prev]');
        this.next = this.querySelector('[data-lightbox-next]');

        this.querySelector('[data-lightbox-close]').addEventListener('click', () => this.close());
        this.prev.addEventListener('click', () => this.go(-1));
        this.next.addEventListener('click', () => this.go(1));
        this.track.addEventListener('scroll', () => {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => this.update());
        }, { passive: true });

        this.track.addEventListener('click', (e) => {
          const slide = e.target.closest('.itrh-lightbox__slide');
          if (!slide || !window.matchMedia('(hover: hover)').matches) return;
          const img = slide.querySelector('img');
          const zoomed = slide.classList.toggle('is-zoomed');
          if (zoomed) this.setOrigin(img, e);
        });

        this.track.addEventListener('pointermove', (e) => {
          const slide = e.target.closest('.itrh-lightbox__slide.is-zoomed');
          if (slide) this.setOrigin(slide.querySelector('img'), e);
        });

        this.onKey = (e) => {
          if (e.key === 'Escape') this.close();
          if (e.key === 'ArrowRight') this.go(1);
          if (e.key === 'ArrowLeft') this.go(-1);
        };
      }

      get slides() {
        return [...this.track.children];
      }

      setOrigin(img, e) {
        const rect = img.getBoundingClientRect();
        const x = ((e.clientX - rect.left) / rect.width) * 100;
        const y = ((e.clientY - rect.top) / rect.height) * 100;
        img.style.transformOrigin = `${x}% ${y}%`;
      }

      open(mediaId) {
        // Keep the same order as the gallery (the variant image may have moved first).
        const gallery = document.querySelector(`#${this.dataset.owner} itrh-gallery`);
        gallery?.items.forEach((item) => {
          const slide = this.track.querySelector(`[data-media-id="${item.dataset.mediaId}"]`);
          if (slide) this.track.append(slide);
        });

        this.hidden = false;
        this.previousFocus = document.activeElement;
        document.body.classList.add('itrh-scroll-lock');
        document.addEventListener('keydown', this.onKey);
        const index = Math.max(0, this.slides.findIndex((s) => s.dataset.mediaId === String(mediaId)));
        this.track.scrollTo({ left: index * this.track.clientWidth, behavior: 'instant' });
        this.slides[index]?.querySelector('img')?.setAttribute('loading', 'eager');
        requestAnimationFrame(() => this.classList.add('is-open'));
        this.update();
        this.querySelector('[data-lightbox-close]').focus({ preventScroll: true });
      }

      close() {
        this.classList.remove('is-open');
        document.removeEventListener('keydown', this.onKey);
        this.slides.forEach((s) => s.classList.remove('is-zoomed'));
        setTimeout(() => {
          this.hidden = true;
          if (!document.querySelector('itrh-drawer.is-open')) document.body.classList.remove('itrh-scroll-lock');
        }, 350);
        this.previousFocus?.focus({ preventScroll: true });
      }

      index() {
        return Math.round(this.track.scrollLeft / (this.track.clientWidth || 1));
      }

      go(step) {
        const i = Math.min(this.slides.length - 1, Math.max(0, this.index() + step));
        this.slides.forEach((s) => s.classList.remove('is-zoomed'));
        this.track.scrollTo({ left: i * this.track.clientWidth, behavior: 'smooth' });
      }

      update() {
        const i = this.index();
        const total = this.slides.length;
        this.counter.textContent = `${i + 1} / ${total}`;
        this.prev.disabled = i <= 0;
        this.next.disabled = i >= total - 1;
      }
    }

    /* ---------------------------------------------------------- Product */
    class ItrhProduct extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.section;

        this.addEventListener('change', (e) => this.onOptionChange(e));
        this.addEventListener('submit', (e) => this.onSubmit(e));
        this.addEventListener('click', (e) => this.onClick(e));

        this.initSticky();
        this.initStickyInfo();
        this.loadRelated();
      }

      disconnectedCallback() {
        this.stickyObserver?.disconnect();
        this.infoObserver?.disconnect();
        this.headerObserver?.disconnect();
        removeEventListener('resize', this.onResize);
      }

      /* Quantity, accordions, share */
      onClick(e) {
        const step = e.target.closest('[data-pqty-step]');
        if (step) {
          const input = step.parentElement.querySelector('input');
          const inc = Number(input.step) || 1;
          const min = Number(input.min) || 1;
          let value = (Number(input.value) || min) + Number(step.dataset.pqtyStep) * inc;
          value = Math.max(min, value);
          if (input.max) value = Math.min(Number(input.max), value);
          input.value = value;
          input.dispatchEvent(new Event('change', { bubbles: true }));
          return;
        }

        const share = e.target.closest('[data-share-url]');
        if (share) {
          const url = share.dataset.shareUrl;
          if (navigator.share) {
            navigator.share({ url, title: share.dataset.shareTitle }).catch(() => {});
          } else {
            navigator.clipboard?.writeText(url).then(() => {
              const label = share.querySelector('[data-share-label]');
              label.textContent = 'Link copied';
              setTimeout(() => (label.textContent = 'Share'), 2000);
            });
          }
        }
      }

      /* Variant change → Section Rendering API */
      onOptionChange(e) {
        const target = e.target;
        if (!target.closest('[data-variant-picker]')) return;

        const chosen = target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
        const productUrl = chosen.dataset.productUrl;
        const label = target.closest('.itrh-vp__option')?.querySelector('[data-selected-value]');
        if (label) label.textContent = chosen.value;

        if (productUrl && productUrl !== this.dataset.url) {
          window.location.href = productUrl;
          return;
        }

        const ids = [...this.querySelectorAll('[data-variant-picker] input:checked, [data-variant-picker] select')]
          .map((el) => (el.tagName === 'SELECT' ? el.selectedOptions[0].dataset.optionValueId : el.dataset.optionValueId))
          .filter(Boolean);

        this.fetchVariant(ids.join(','), target.id);
      }

      async fetchVariant(optionValues, focusId) {
        this.controller?.abort();
        this.controller = new AbortController();
        this.classList.add('is-updating');

        try {
          const response = await fetch(
            `${this.dataset.url}?option_values=${optionValues}&section_id=${this.sectionId}`,
            { signal: this.controller.signal }
          );
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          const source = doc.querySelector('itrh-product');
          if (!source) return;

          this.querySelectorAll('[data-update]').forEach((node) => {
            const next = source.querySelector(`[data-update="${node.dataset.update}"]`);
            if (next) node.replaceWith(next);
          });

          // Drawers portal themselves to <body>; keep only the newest copy.
          requestAnimationFrame(() => {
            const pickups = document.querySelectorAll(`itrh-drawer[id="Pickup-${this.sectionId}"]`);
            [...pickups].slice(0, -1).forEach((old) => old.remove());
          });

          const variant = JSON.parse(this.querySelector('[data-selected-variant]')?.textContent || 'null');

          if (variant) {
            const url = new URL(window.location.href);
            url.searchParams.set('variant', variant.id);
            history.replaceState({}, '', url.toString());
            if (variant.featured_media) this.querySelector('itrh-gallery')?.setActiveMedia(variant.featured_media.id);
          } else {
            this.querySelectorAll('[data-add-button], [data-sticky-buy] button').forEach((btn) => {
              btn.disabled = true;
              const labelEl = btn.querySelector('[data-add-label]') || btn;
              labelEl.textContent = 'Unavailable';
            });
          }

          if (focusId) document.getElementById(focusId)?.focus({ preventScroll: true });
          window.Shopify?.PaymentButton?.init?.();
          this.initSticky();
          this.dispatchEvent(new CustomEvent('itrh:variant-change', { bubbles: true, detail: { variant } }));
        } catch (error) {
          if (error.name !== 'AbortError') console.error(error);
        } finally {
          this.classList.remove('is-updating');
        }
      }

      /* Add to cart → ITRH cart drawer */
      async onSubmit(e) {
        const form = e.target;
        if (!form.matches('.itrh-buy__form')) return;
        e.preventDefault();

        const button = form.querySelector('[data-add-button]');
        const error = form.querySelector('[data-form-error]');
        if (!button || button.disabled || button.classList.contains('is-loading')) return;

        button.classList.add('is-loading');
        button.setAttribute('aria-busy', 'true');
        error.hidden = true;

        const cart = document.querySelector('cart-drawer');
        const formData = new FormData(form);
        if (cart?.getSectionsToRender) {
          formData.append('sections', cart.getSectionsToRender().map((section) => section.id));
          formData.append('sections_url', window.location.pathname);
          cart.setActiveElement?.(document.activeElement);
        }

        try {
          const response = await fetch(`${shopRoot()}cart/add.js`, {
            method: 'POST',
            headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
            body: formData,
          });
          const data = await response.json();

          if (data.status) {
            error.textContent = data.description || data.message || 'Something went wrong. Please try again.';
            error.hidden = false;
            if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
              window.publish(window.PUB_SUB_EVENTS.cartError, { source: 'product-form', errors: data.description || data.message });
            }
            return;
          }

          if (!cart?.renderContents) {
            window.location.href = window.routes?.cart_url || `${shopRoot()}cart`;
            return;
          }

          if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
            window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id'), cartData: data });
          }
          button.classList.add('is-added');
          setTimeout(() => button.classList.remove('is-added'), 700);
          cart.renderContents(data);
        } catch (_) {
          error.textContent = 'Something went wrong. Please try again.';
          error.hidden = false;
        } finally {
          button.classList.remove('is-loading');
          button.removeAttribute('aria-busy');
        }
      }

      /* Sticky add-to-cart bar */
      initSticky() {
        this.stickyObserver?.disconnect();
        const bar = this.querySelector('[data-sticky-buy]');
        const main = this.querySelector('[data-add-button]');
        if (!bar || !main) return;
        this.stickyObserver = new IntersectionObserver(([entry]) => {
          const show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          bar.classList.toggle('is-visible', show);
          bar.setAttribute('aria-hidden', String(!show));
          bar.querySelector('button').tabIndex = show ? 0 : -1;
        });
        this.stickyObserver.observe(main);
      }

      /* Smart sticky columns: the shorter column stays in view while the longer one scrolls.
         A column taller than the screen sticks by its bottom edge, so all of it can be seen. */
      initStickyInfo() {
        const columns = [...this.querySelectorAll('.itrh-product__info--sticky, .itrh-product__media--sticky')];
        if (!columns.length) return;
        const root = document.documentElement;

        const set = () => {
          const headerVisible = root.dataset.itrhSticky === 'static' ||
            (root.dataset.itrhSticky === 'dynamic' && !root.hasAttribute('data-itrh-header-hidden'));
          const headerOffset = headerVisible
            ? (parseFloat(getComputedStyle(root).getPropertyValue('--itrh-header-h')) || 0) +
              (parseFloat(getComputedStyle(root).getPropertyValue('--itrh-sticky-top')) || 0)
            : 0;
          const top = headerOffset + 24;
          columns.forEach((column) => {
            const overflow = window.innerHeight - column.offsetHeight - 24;
            column.style.setProperty('--pd-sticky-top', `${Math.min(top, overflow)}px`);
          });
        };

        this.infoObserver = new ResizeObserver(set);
        columns.forEach((column) => this.infoObserver.observe(column));
        this.onResize = set;
        addEventListener('resize', set, { passive: true });

        // Follow the header as it hides/shows on scroll.
        this.headerObserver = new MutationObserver(set);
        this.headerObserver.observe(root, { attributes: true, attributeFilter: ['data-itrh-header-hidden', 'data-itrh-sticky'] });
        set();
      }

      /* Automatic related products */
      async loadRelated() {
        const holders = this.querySelectorAll('[data-related-auto]');
        for (const holder of holders) {
          try {
            const url = `${shopRoot()}recommendations/products?section_id=${this.sectionId}&product_id=${this.dataset.productId}&limit=${holder.dataset.limit}&intent=related`;
            const doc = new DOMParser().parseFromString(await (await fetch(url)).text(), 'text/html');
            const content = doc.getElementById(`ItrhRelated-${holder.dataset.relatedAuto}`);
            if (content) holder.innerHTML = content.innerHTML;
          } catch (_) {}
        }
      }
    }

    /* Accordions (document-level so they also work inside drawers) */
    document.addEventListener('click', (e) => {
      const toggle = e.target.closest('[data-accordion]');
      if (!toggle) return;
      const acc = toggle.closest('.itrh-acc');
      const open = !acc.classList.contains('is-open');
      acc.classList.toggle('is-open', open);
      toggle.setAttribute('aria-expanded', String(open));
    });

    document.addEventListener('shopify:section:unload', (e) => {
      document.querySelectorAll(`itrh-lightbox[data-owner="${e.target.id}"]`).forEach((el) => el.remove());
    });

    customElements.define('itrh-gallery', ItrhGallery);
    customElements.define('itrh-lightbox', ItrhLightbox);
    customElements.define('itrh-product', ItrhProduct);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["itrh-main-search"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.itrhSearchDefaultReady) return;
    window.itrhSearchDefaultReady = true;

    const section = document.querySelector('[data-search-sku]');
    if (!section) return;

    const url = new URL(window.location.href);
    const q = (url.searchParams.get('q') || '').trim();
    if (!q) return;

    // Old links may still carry "AND"; the storefront search does not use operators
    if (/(^|\s)AND(\s|$)/.test(q)) {
      url.searchParams.set('q', q.replace(/(^|\s)AND(\s|$)/g, ' ').replace(/\s+/g, ' ').trim());
      url.searchParams.delete('all_words');
      window.location.replace(url.toString());
      return;
    }

    // A SKU search that found nothing: try the same words in capitals, once
    if (section.dataset.searchUpper === 'true' && !url.searchParams.get('sku_case')) {
      url.searchParams.set('q', q.toUpperCase());
      url.searchParams.set('sku_case', '1');
      window.location.replace(url.toString());
      return;
    }

    const vendorParam = section.dataset.vendorParam;
    const preferred = section.dataset.searchDefault;
    const wantsAll = url.searchParams.get('vendors') === 'all';
    const fields = url.searchParams.get('options[fields]') || '';
    let changed = false;

    // Clean up any old "vendor:" clause so it never counts as a search word
    if (q.includes('vendor:')) {
      const plain = q.split('vendor:')[0].trim();
      const vendorValue = q.split('vendor:')[1].replace(/"/g, '').trim();
      url.searchParams.set('q', plain);
      if (vendorParam && vendorValue) url.searchParams.set(vendorParam, vendorValue);
      changed = true;
    }

    const words = (url.searchParams.get('q') || '').trim();

    // A SKU-like search (one word containing a digit) searches the SKU field only
    const looksLikeSku = /^[a-z0-9][a-z0-9._/-]*$/i.test(words) && /\d/.test(words);
    const wordFields = section.dataset.searchFields || 'title,product_type,variants.sku,vendor,tag';
    const wanted = looksLikeSku && section.dataset.searchSku === 'true' ? 'variants.sku' : wordFields;

    if (fields !== wanted) {
      url.searchParams.set('options[fields]', wanted);
      changed = true;
    }

    // First search lands on the preferred store unless "All" was chosen
    const hasVendor = vendorParam ? url.searchParams.has(vendorParam) : false;
    if (preferred && vendorParam && !hasVendor && !wantsAll) {
      url.searchParams.set(vendorParam, preferred);
      changed = true;
    }

    if (changed) {
      window.location.replace(url.toString());
      return;
    }

    /* ----------------------------------------------------------------------
       Shopify pages its results before this section filters them, so a page
       can come back with few matches or none. Pull in the next pages until
       the grid is full, and let the shopper load more after that.
    ---------------------------------------------------------------------- */
    const box = () => document.querySelector('[data-search-results]');
    if (!box()) return;

    const grid = (name) => box()?.querySelector(`[data-search-grid="${name}"]`);
    const shown = () => box()?.querySelectorAll('.itrh-coll__item').length || 0;
    const moreLink = () => box()?.querySelector('[data-search-more]');

    const sync = () => {
      const results = box();
      if (!results) return;

      ['main', 'related'].forEach((name) => {
        const list = grid(name);
        const head = results.querySelector(`[data-search-head="${name}"]`);
        const has = list && list.children.length > 0;
        if (list) list.hidden = !has;
        if (head) head.hidden = !has;
      });

      const total = shown();
      const empty = results.querySelector('[data-search-empty]');
      if (empty) empty.hidden = total > 0 || !!moreLink();

      const countEl = document.querySelector('[data-search-count]');
      if (countEl) countEl.textContent = `${total} ${total === 1 ? 'result' : 'results'}`;
    };

    let loading = false;

    const loadNext = async () => {
      const link = moreLink();
      if (!link || loading) return;
      loading = true;
      link.classList.add('is-loading');

      try {
        const html = await (await fetch(link.href)).text();
        const doc = new DOMParser().parseFromString(html, 'text/html');

        ['main', 'related'].forEach((name) => {
          const from = doc.querySelector(`[data-search-grid="${name}"]`);
          const into = grid(name);
          if (!from || !into) return;
          Array.from(from.children).forEach((item) => {
            item.removeAttribute('data-reveal');
            into.append(item);
          });
        });

        const pager = box()?.querySelector('[data-search-pager]');
        const nextPager = doc.querySelector('[data-search-pager]');
        if (pager) pager.replaceWith(nextPager || document.createElement('div'));
      } catch (_) {
        box()?.querySelector('[data-search-pager]')?.remove();
      }

      loading = false;
      sync();
    };

    // Fill the first screen, then leave the rest to the button
    const fill = async () => {
      const target = Number(box()?.dataset.searchTarget || 24);
      let guard = 0;
      while (shown() < target && moreLink() && guard < 12) {
        guard += 1;
        // eslint-disable-next-line no-await-in-loop
        await loadNext();
      }
      sync();
    };

    document.addEventListener('click', (e) => {
      const button = e.target.closest('[data-search-more]');
      if (!button) return;
      e.preventDefault();
      loadNext();
    });

    // Filtering and sorting swap the results block out: start over when they do
    const region = document.querySelector('[data-coll-update="results"]');
    if (region && 'MutationObserver' in window) {
      new MutationObserver(() => fill()).observe(region, { childList: true, subtree: false });
    }

    sync();
    fill();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["itrh-multiple-collections"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.itrhMcolReady) return;
    window.itrhMcolReady = true;

    const activate = (section, index) => {
      section.querySelectorAll('[data-mcol-tab]').forEach((tab) => {
        tab.setAttribute('aria-selected', String(tab.dataset.mcolTab === index));
      });
      section.querySelectorAll('[data-mcol-panel]').forEach((panel) => {
        const active = panel.dataset.mcolPanel === index;
        panel.hidden = !active;
        panel.classList.toggle('is-active', active);
        if (!active) return;
        panel.classList.remove('is-switching');
        void panel.offsetWidth;
        panel.classList.add('is-switching');
        // The carousel measured itself while hidden, so re-measure it now.
        const carousel = panel.querySelector('itrh-carousel');
        requestAnimationFrame(() => carousel?.embla?.reInit());
      });
    };

    document.addEventListener('click', (e) => {
      const tab = e.target.closest('[data-mcol-tab]');
      if (!tab) return;
      activate(tab.closest('.itrh-mcol'), tab.dataset.mcolTab);
    });

    document.addEventListener('keydown', (e) => {
      const tab = e.target.closest('[data-mcol-tab]');
      if (!tab || !['ArrowLeft', 'ArrowRight'].includes(e.key)) return;
      const tabs = [...tab.closest('.itrh-mcol__tabs').querySelectorAll('[data-mcol-tab]')];
      const next = tabs[(tabs.indexOf(tab) + (e.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length];
      next.focus();
      activate(tab.closest('.itrh-mcol'), next.dataset.mcolTab);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["itrh-password-header"]) return;
  try {
    
  (() => {
    if (window.itrhPasswordReady) return;
    window.itrhPasswordReady = true;

    const open = (modal) => {
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
      const input = modal.querySelector('[data-pw-input]');
      (input || modal.querySelector('[role="dialog"]')).focus();
    };

    const close = (modal) => {
      modal.hidden = true;
      document.body.style.overflow = '';
    };

    document.addEventListener('click', (e) => {
      const trigger = e.target.closest('[data-pw-open]');
      if (trigger) {
        const modal = document.getElementById(trigger.dataset.pwOpen);
        if (modal) open(modal);
        return;
      }
      if (e.target.closest('[data-pw-close]')) {
        const modal = e.target.closest('.itrh-pw-modal');
        if (modal) close(modal);
      }
    });

    document.addEventListener('keydown', (e) => {
      if (e.key !== 'Escape') return;
      document.querySelectorAll('.itrh-pw-modal:not([hidden])').forEach(close);
    });

    // A wrong password reloads the page: reopen the modal with the error showing
    if (document.querySelector('[data-pw-error]')) {
      const modal = document.querySelector('[data-pw-error]').closest('.itrh-pw-modal');
      if (modal) open(modal);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["itrh-product-recommendations"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const load = async (section) => {
      const url = section.dataset.recsUrl;
      if (!url || section.dataset.loaded) return;
      section.dataset.loaded = 'true';
      try {
        const html = await (await fetch(url)).text();
        const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-recs-section]');
        if (fresh) section.replaceWith(fresh);
        window.itrh?.reveal?.();
      } catch (_) {}
    };

    const observer = 'IntersectionObserver' in window
      ? new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            observer.unobserve(entry.target);
            load(entry.target);
          });
        }, { rootMargin: '0px 0px 600px 0px' })
      : null;

    const init = () => {
      document.querySelectorAll('[data-recs-section][data-recs-url]:not([data-loaded])').forEach((el) => {
        observer ? observer.observe(el) : load(el);
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init, { once: true });
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["itrh-slideshow"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.itrhSlidesReady) return;
    window.itrhSlidesReady = true;

    document.addEventListener('click', (e) => {
      const button = e.target.closest('[data-slides-play]');
      if (!button) return;
      const carousel = button.closest('itrh-carousel');
      const paused = button.getAttribute('aria-pressed') === 'true';
      if (paused) {
        carousel?.autoplay?.play();
        button.setAttribute('aria-pressed', 'false');
        button.setAttribute('aria-label', 'Pause slideshow');
      } else {
        carousel?.autoplay?.stop();
        button.setAttribute('aria-pressed', 'true');
        button.setAttribute('aria-label', 'Play slideshow');
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["itrh-video-banner"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('itrh-video')) return;

    class ItrhVideo extends HTMLElement {
      connectedCallback() {
        this.cover = this.querySelector('[data-video-cover]');
        this.querySelector('[data-video-play]')?.addEventListener('click', () => this.play());

        // Pause hosted videos while off screen to save data and battery
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(
            ([entry]) => {
              this.querySelectorAll('video').forEach((video) => {
                if (!this.hasAttribute('data-autoplay') && !this.classList.contains('is-playing')) return;
                if (entry.isIntersecting) video.play?.().catch(() => {});
                else video.pause?.();
              });
            },
            { threshold: 0.2 }
          );
          this.observer.observe(this);
        }
      }

      disconnectedCallback() {
        this.observer?.disconnect();
      }

      play() {
        this.classList.add('is-playing');

        const video = this.querySelector('video:not([style*="display: none"])');
        if (video) {
          video.controls = true;
          video.play?.().catch(() => {});
        }

        // Load YouTube/Vimeo only now, so the page stays fast
        this.querySelectorAll('[data-embed-id]').forEach((holder) => {
          if (holder.querySelector('iframe')) return;
          const id = holder.dataset.embedId;
          const src =
            holder.dataset.embedType === 'vimeo'
              ? `https://player.vimeo.com/video/${id}?autoplay=1&muted=1&playsinline=1`
              : `https://www.youtube.com/embed/${id}?autoplay=1&playsinline=1&rel=0`;
          const iframe = document.createElement('iframe');
          iframe.src = src;
          iframe.title = 'Video';
          iframe.allow = 'autoplay; encrypted-media; picture-in-picture';
          iframe.allowFullscreen = true;
          holder.append(iframe);
        });
      }
    }

    customElements.define('itrh-video', ItrhVideo);
  })();

  } catch(e) { console.error(e); }
})();
})();
